const defaultCourseColors = {
    Course1: '947550',
    Course2: '002cff',
    Course3: '007a77',
    Course4: 'a300db',
    Default: '666666'
 };

const getDefaultCourseColors = (crsNum) => {
    switch (crsNum) {
       case 1:
          return defaultCourseColors.Course1;
       case 2:
          return defaultCourseColors.Course2;
       case 3:
          return defaultCourseColors.Course3;
       case 4:
          return defaultCourseColors.Course4;
       default:
          return defaultCourseColors.Default;
    }
 };

 export const vc = {
    getDefaultCourseColors
 }